
import ClearAllIcon from '@mui/icons-material/ClearAll';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import FilterHelper from '../../../helpers/filterHelper';
import ButtonWrapper from '../../../shared/formUtilities/useButton';
import DatePickerWrapper from '../../../shared/formUtilities/useDatePicker';
import SelectWrapper from '../../../shared/formUtilities/useSelect';
import TextWrapper from '../../../shared/formUtilities/useTextWrapper';

const CouponType = {
  Fixed: 1,
  Percentage: 2
};

export const PromoCodeFilter = ({
  loading = false,
  filter,
  onHandleFilter = (e) => { },
  onClearFilter = (e) => { },
}) => {
  const [expand, setExpand] = useState(false);
  const initialValues = {
    isActive: FilterHelper.mapFilterStringToForm(filter, 'isActive'),
    type: FilterHelper.mapFilterStringToForm(filter, 'type'),
    startDate: FilterHelper.mapFilterStringToForm(filter, 'startDate'),
    expiryDate: FilterHelper.mapFilterStringToForm(filter, 'expiryDate'),
  };

  function onFilter(values) {
    onHandleFilter && onHandleFilter(FilterHelper.checkMuliSelectValues(values));
  }

  function onClear(formik) {
    formik.resetForm();
    onClearFilter && onClearFilter({});
  }

  return (
    <Box className="bg-white">
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={onFilter}>
        {(formik) => {
          return (
            <Form>
              <Box className="bg-white">
                <Accordion
                  sx={{ boxShadow: 'none' }}
                  expanded={expand}>
                  <AccordionSummary
                    className={`h-10 !min-h-[1rem]`}
                    onClick={() => {
                      setExpand(!expand);
                    }}
                    sx={{
                      margin: '0px',
                      borderBottom: `${expand ? '1px solid #ccc' : ''}`,
                    }}>
                    <Box className="flex justify-start items-center w-full">
                      <TextWrapper
                        classList="caption"
                        text="Advanced Filter"></TextWrapper>
                      {expand ? (
                        <ExpandLessIcon className="caption"></ExpandLessIcon>
                      ) : (
                        <ExpandMoreIcon className="caption"></ExpandMoreIcon>
                      )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="flex flex-col flex-1">
                      <Box className="flex flex-col flex-1">
                        <Box className="grid grid-cols-2 md:grid-cols-4 gap-4">
                          <SelectWrapper
                            classList="!w-full"
                            items={[{ name: 'Fixed', displayName: 'Fixed', id: CouponType.Fixed },
                            { name: 'Percentage', displayName: 'Percentage', id: CouponType.Percentage }]}
                            key={'type'}
                            name={'type'}
                            label={'Code Type'}
                          />
                          <SelectWrapper
                            classList="!w-full"
                            items={[{ name: 'Active', displayName: 'Active', id: 'true' },
                            { name: 'Deactive', displayName: 'Deactive', id: 'false' }]}
                            key={'isActive'}
                            name={'isActive'}
                            label={'Active/Deactive'}
                          />
                          <DatePickerWrapper key={'startDate'} name={'startDate'} label={'Validity Start Date'} />
                          <DatePickerWrapper key={'expiryDate'} name={'expiryDate'} label={'Validity End Date'} />
                        </Box>
                      </Box>
                    </Box>

                    <Box className="flex justify-end items-center pt-4">
                      <Box className="flex flex-0 flex-col md:flex-row">
                        <ButtonWrapper
                          loading={loading}
                          classList="w-[140px] !mb-3 md:!mx-2"
                          label="Search"
                          type="submit"
                          icon={<ManageSearchIcon />}></ButtonWrapper>
                        <ButtonWrapper
                          loading={loading}
                          variant="outlined"
                          onClick={(e) => onClear(formik)}
                          classList="w-[140px] !text-primary"
                          label="Reset"
                          loaderSpinnerClass={'!text-primary'}
                          icon={<ClearAllIcon />}></ButtonWrapper>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};